<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('riders.categories.edit', { id: vm.$route.params.categoryId })
  }),
  computed: {
    ...mapState('ridersCategories', ['routeKey', 'routes', 'form', 'item']),
    crumbs: vm => [
      { text: vm.$t('riders.title'), to: { name: 'riders.index' } },
      { text: vm.$t('riders.categories.title'), to: { name: 'riders.categories.index' } },
      { text: vm.$t('riders.categories.edit', { id: vm.$route.params.categoryId }) }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('ridersCategories/fetchItem', { route: to })
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('ridersCategories', ['createItem', 'updateItem'])
  }
}
</script>
